import React from 'react';
import PropTypes from 'prop-types';
import './SearchFormInline.scss';

class SearchForm extends React.PureComponent {
    static propTypes = {
        inputPlaceholder: PropTypes.string,
        baseUrl: PropTypes.string
    }

    render() {
        return (
            <div className="search-form-inline">
                <form className="search-form-inline-wrapper" action={this.props.baseUrl} method="get">
                    <input type="text" placeholder={this.props.inputPlaceholder} name="query" id="inline-search" className="search-form-inline-input" />
                </form>
            </div>
        );
    }
}

export default SearchForm;



// WEBPACK FOOTER //
// ./src/components/SearchFormInline/SearchFormInline.jsx